import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

// recoilPersist 설정
const { persistAtom } = recoilPersist({
  key: 'recoil-persist', // LocalStorage에 저장될 key
  storage: sessionStorage, // 저장 방식: localStorage
});

// Order ID를 저장하는 atom 정의
export const vehicleState = atom<string | null>({
  key: 'vehicleState', // 각 atom의 고유한 ID (key)
  default: null, // 기본값 설정
  effects_UNSTABLE: [persistAtom], // Recoil Persist를 통해 localStorage에 상태를 저장
});
